import {
  COLOUR_BLUE,
  COLOUR_AZURE,
  COLOUR_CYAN,
  COLOUR_GREEN,
  COLOUR_GREY,
  COLOUR_LIME,
  COLOUR_MAGENTA,
  COLOUR_ORANGE,
  COLOUR_PURPLE,
  COLOUR_RED,
  COLOUR_VOLCANO,
  COLOUR_YELLOW,
} from 'approot/shared/colour/colour.constants';
import { ActivitiesComponentType } from 'global/constants';

export const COMPONENT_COLOURS = [
  COLOUR_GREY,
  COLOUR_MAGENTA,
  COLOUR_RED,
  COLOUR_VOLCANO,
  COLOUR_ORANGE,
  COLOUR_YELLOW,
  COLOUR_LIME,
  COLOUR_GREEN,
  COLOUR_CYAN,
  COLOUR_BLUE,
  COLOUR_AZURE,
  COLOUR_PURPLE,
];

export type ComponentOuterStyle = {
  __typename: 'ComponentStyle';
  outerBorder: boolean | null;
  outerBaseColour: string | null;
  outerBackgroundColour: boolean | null;
  [key: string]: any;
};

export type ComponentSettingsBordersProps = {
  componentId: string;
  sectionId: string;
  style?: ComponentOuterStyle;
  type: ActivitiesComponentType;
};
